import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import type { AllRawData } from '../../raw-types.ts';

export const PetSummonLevelSchema = defineSchema({
  name: 'serverPetSummonLevels',
  fields: [
    ['level', 'number'],
    ['minSummonCount', 'number'],
    ['maxSummonCount', 'number?'],
    ['minimumGrade', 'number'],
    ['guaranteeCount', 'number'],
    ['goldenGrade', 'number'],
    ['goldenGuaranteeCount', 'number'],
    [
      'probabilities',
      { kind: 'record', value: { kind: 'array', of: { kind: 'array', of: 'number' } } },
    ],
  ],
  lookupKeys: ['minSummonCount', 'maxSummonCount'],
});

export interface RawPetSummonLevelRow {
  level: number;
  summon_count: number;
  minimum_grade: number;
  guarantee_count: number;
  golden_grade: number;
  golden_guarantee_count: number;
}

export function petSummonLevelFromRaw(
  row: RawPetSummonLevelRow,
  raw: Pick<AllRawData, 'pet_summon_level' | 'pet_summon_probability'>
) {
  const sorted = (raw.pet_summon_level ?? []).slice().sort((a, b) => a.level - b.level);

  const idx = sorted.findIndex((r) => r.level === row.level);
  const prevRow = idx > 0 ? sorted[idx - 1] : null;
  const minSummonCount = prevRow ? prevRow.summon_count + 1 : 0;
  const maxSummonCount = idx === sorted.length - 1 ? null : row.summon_count;

  const byType: Record<string, [number, number][]> = {};
  for (const p of (raw.pet_summon_probability ?? []).filter((p) => p.level === row.level)) {
    const key = p.summon_type as string;
    if (!byType[key]) byType[key] = [];
    byType[key].push([p.pet_id, p.weight]);
  }

  return {
    level: row.level,
    minSummonCount,
    maxSummonCount,
    minimumGrade: row.minimum_grade,
    guaranteeCount: row.guarantee_count,
    goldenGrade: row.golden_grade,
    goldenGuaranteeCount: row.golden_guarantee_count,
    probabilities: byType,
  };
}

registerCategorySchema('serverPetSummonLevels', PetSummonLevelSchema);
